import React from 'react';
import { PortalModalTrigger } from './PortalOverlay';

interface ModalTriggerProps {
  initialOpen?: boolean;
  renderModal: (requestClose: () => void) => React.ReactNode;
  renderTrigger?: (requestOpen: () => void) => React.ReactNode;
  onModalOpen?: () => void;
  onModalClose?: () => void;
}

/**
 * @deprecated Use PortalOverlay pattern instead
 * Provides an interface to render and open Modals.
 *
 * @example Modal opened immediately on mount
 *   <ModalTrigger
 *     renderModal={(close) => (
 *       <Modal onCloseRequest={close}>
 *         <Text>Example content</Text>
 *       </Modal>
 *     )}
 *   />
 *
 * @example Modal opened on button click
 *   <ModalTrigger
 *     renderModal={(close) => (
 *       <Modal onCloseRequest={close}>
 *         <Text>Example content</Text>
 *       </Modal>
 *     )}
 *     renderTrigger={(open) => (
 *       <Button text="Open" onClick={open} />
 *     )}
 *   />
 *
 * @example Modal opened initially and on button click
 *   <ModalTrigger
 *     renderModal={(close) => (
 *       <Modal onCloseRequest={close}>
 *         <Text>Example content</Text>
 *       </Modal>
 *     )}
 *     renderTrigger={(open) => (
 *       <Button text="Open" onClick={open} />
 *     )}
 *     initialOpen
 *   />
 *
 * @example Modal with response
 *   <ModalTrigger
 *     renderModal={(close) => (
 *       <ConfirmModal ok={() => close(true)} cancel={() => close(false)}>
 *         <Text>Example question?</Text>
 *       </ConfirmModal>
 *     )}
 *     renderTrigger={(open) => (
 *       <Button text="Open" onClick={open} />
 *     )}
 *     onModalClose={(confirmed) => (confirmed
 *       ? handleOk()
 *       : handleCancel()
*      )}
 *   />
 *
 * See also:
 *   Modal
 *   ModalHost
 */
const ModalTrigger: React.FCWithChildren<ModalTriggerProps> = ({
  renderModal,
  renderTrigger,
  onModalOpen,
  onModalClose,
  initialOpen,
}) => (
  <PortalModalTrigger
    name="deprecatedModalTrigger"
    renderModal={renderModal}
    renderTrigger={renderTrigger}
    immediateOpen={initialOpen}
    onOpen={onModalOpen}
    onClose={onModalClose}
  />
);

export default ModalTrigger;
